module.exports = __webpack_public_path__ + "img/test-drive_mobile.3d39948d.jpg";